<template>
  <div class="xmm" tabindex="0" @keydown="onKey">
    <div class="xmm-bar">
      <div class="xmm-keys">
        <span class="xmm-key"><kbd>Tab</kbd> 子</span>
        <span class="xmm-key"><kbd>Enter</kbd> 同级</span>
        <span class="xmm-key"><kbd>F2</kbd> 编辑</span>
        <span class="xmm-key"><kbd>Del</kbd> 删</span>
        <span class="xmm-key"><kbd>&larr;&uarr;&darr;&rarr;</kbd></span>
      </div>
      <div class="xmm-acts">
        <el-dropdown @command="onExport" trigger="click">
          <el-button size="mini" plain icon="el-icon-download">导出</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="json">JSON 格式</el-dropdown-item>
            <el-dropdown-item command="markdown">Markdown 大纲</el-dropdown-item>
            <el-dropdown-item command="png" divided>PNG 图片</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="switchTheme" trigger="click">
          <el-button size="mini" plain>风格</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(t,k) in themes" :key="k" :command="k">{{ t.name }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button size="mini" plain icon="el-icon-star-off" @click="loadSample">{{ $t("common.action.sample") }}</el-button>
        <el-button size="mini" plain icon="el-icon-zoom-in" @click="z(0.15)" />
        <span class="xmm-pct">{{ Math.round(scale*100) }}%</span>
        <el-button size="mini" plain icon="el-icon-zoom-out" @click="z(-0.15)" />
        <el-button size="mini" plain @click="fit">适应</el-button>
      </div>
    </div>

    <div class="xmm-stage" :style="{background:stageBg}" @wheel.prevent="onWheel" @mousedown.left="onDown" @mousemove="onMove" @mouseup="onUp" @mouseleave="onUp">
      <div class="xmm-world" :style="{transform:'scale('+scale+') translate('+panX+'px,'+panY+'px)',transformOrigin:'0 0'}">
        <svg :width="svgW" :height="svgH" :key="renderKey">
          <defs>
            <filter id="sd"><feDropShadow dx="0" dy="1.5" stdDeviation="2.5" flood-opacity="0.12" /></filter>
            <filter id="sd-root"><feDropShadow dx="0" dy="2" stdDeviation="4" flood-opacity="0.18" /></filter>
            <linearGradient v-for="g in gradients" :key="g.id" :id="g.id" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" :stop-color="g.from" />
              <stop offset="100%" :stop-color="g.to" />
            </linearGradient>
          </defs>
          <!-- dot grid background -->
          <pattern id="dots" x="0" y="0" width="24" height="24" patternUnits="userSpaceOnUse">
            <circle cx="12" cy="12" r="0.8" :fill="dotColor" />
          </pattern>
          <rect x="0" y="0" :width="svgW" :height="svgH" :fill="bgColor" />
          <rect x="0" y="0" :width="svgW" :height="svgH" fill="url(#dots)" />
          <!-- connecting lines -->
          <g v-for="l in lines" :key="'L'+l.id">
            <path :d="l.d" fill="none" :stroke="l.c" stroke-width="2" opacity="0.3" stroke-linecap="round" />
          </g>
          <!-- nodes -->
          <g v-for="n in nodes" :key="n.id" :transform="'translate('+n.x+','+n.y+')'">
            <rect :width="n.w" :height="n.depth===0?36:28" :rx="n.depth===0?10:7"
              :fill="selId===n.id?'#fff':('url(#'+n.gr+')')"
              :stroke="selId===n.id?n.brdr:'none'"
              :stroke-width="selId===n.id?2:0"
              :filter="n.depth===0?'url(#sd-root)':'url(#sd)'"
              style="cursor:pointer"
              @click.stop="selId=n.id" @dblclick.stop="startEdit(n)" />
            <text v-if="editId!==n.id"
              :x="n.w/2" :y="n.depth===0?25:19" text-anchor="middle"
              :fill="selId===n.id?n.brdr:'#fff'"
              :font-size="n.depth===0?'15':'13'"
              font-family="-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"
              :font-weight="n.depth===0?'700':'500'"
              style="pointer-events:none">{{ n.label }}</text>
          </g>
          <foreignObject v-if="edBox" :x="edBox.x-1" :y="edBox.y-3" :width="edBox.w+6" :height="edBox.depth===0?40:32">
            <input ref="ef" v-model="edText" class="xmm-inp" :class="edBox.depth===0?'xmm-inp-root':''"
              @keyup.enter="finishEdit" @keyup.esc="cancelEdit" @blur="finishEdit" />
          </foreignObject>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
var THEMES = {
  'default': {
    name: '默认', bg: '#fff', dot: '#dce0e8',
    pal: [
      { from: '#4e7cff', to: '#3b5ccc' }, { from: '#10b981', to: '#059669' },
      { from: '#f59e0b', to: '#d97706' }, { from: '#ef4444', to: '#dc2626' },
      { from: '#8b5cf6', to: '#6d28d9' }, { from: '#06b6d4', to: '#0891b2' },
      { from: '#ec4899', to: '#db2777' }, { from: '#f97316', to: '#ea580c' },
      { from: '#14b8a6', to: '#0d9488' }, { from: '#a855f7', to: '#7c3aed' }
    ]
  },
  'warm': {
    name: '暖橙', bg: '#fffbf5', dot: '#fde8d0',
    pal: [
      { from: '#f97316', to: '#ea580c' }, { from: '#ef4444', to: '#dc2626' },
      { from: '#ec4899', to: '#db2777' }, { from: '#f59e0b', to: '#d97706' },
      { from: '#eab308', to: '#ca8a04' }, { from: '#f43f5e', to: '#e11d48' },
      { from: '#d946ef', to: '#c026d3' }, { from: '#fb923c', to: '#f97316' },
      { from: '#fbbf24', to: '#f59e0b' }, { from: '#f87171', to: '#ef4444' }
    ]
  },
  'cool': {
    name: '极客', bg: '#f8faff', dot: '#d4ddf8',
    pal: [
      { from: '#6366f1', to: '#4f46e5' }, { from: '#06b6d4', to: '#0891b2' },
      { from: '#8b5cf6', to: '#6d28d9' }, { from: '#0ea5e9', to: '#0284c7' },
      { from: '#14b8a6', to: '#0d9488' }, { from: '#a855f7', to: '#7c3aed' },
      { from: '#3b82f6', to: '#2563eb' }, { from: '#2dd4bf', to: '#14b8a6' },
      { from: '#7c3aed', to: '#6d28d9' }, { from: '#38bdf8', to: '#0ea5e9' }
    ]
  },
  'forest': {
    name: '森林', bg: '#f8fdf9', dot: '#c8e6d0',
    pal: [
      { from: '#10b981', to: '#059669' }, { from: '#22c55e', to: '#16a34a' },
      { from: '#14b8a6', to: '#0d9488' }, { from: '#84cc16', to: '#65a30d' },
      { from: '#06b6d4', to: '#0891b2' }, { from: '#4ade80', to: '#22c55e' },
      { from: '#2dd4bf', to: '#14b8a6' }, { from: '#a3e635', to: '#84cc16' },
      { from: '#34d399', to: '#10b981' }, { from: '#0ea5e9', to: '#0284c7' }
    ]
  },
  'dark': {
    name: '暗夜', bg: '#1e1e2e', dot: '#2e2e42',
    pal: [
      { from: '#818cf8', to: '#6366f1' }, { from: '#34d399', to: '#10b981' },
      { from: '#fbbf24', to: '#f59e0b' }, { from: '#f87171', to: '#ef4444' },
      { from: '#a78bfa', to: '#8b5cf6' }, { from: '#22d3ee', to: '#06b6d4' },
      { from: '#f472b6', to: '#ec4899' }, { from: '#fb923c', to: '#f97316' },
      { from: '#2dd4bf', to: '#14b8a6' }, { from: '#c084fc', to: '#a855f7' }
    ]
  },
  'sunset': {
    name: '晚霞', bg: '#fff8f6', dot: '#fdd4cc',
    pal: [
      { from: '#f43f5e', to: '#e11d48' }, { from: '#f59e0b', to: '#d97706' },
      { from: '#8b5cf6', to: '#6d28d9' }, { from: '#ec4899', to: '#db2777' },
      { from: '#f97316', to: '#ea580c' }, { from: '#3b82f6', to: '#2563eb' },
      { from: '#eab308', to: '#ca8a04' }, { from: '#d946ef', to: '#c026d3' },
      { from: '#fb923c', to: '#f97316' }, { from: '#06b6d4', to: '#0891b2' }
    ]
  }
}

var PAL = THEMES['default'].pal
var BG = THEMES['default'].bg
var DOT = THEMES['default'].dot
var NH = 28, NRH = 36, XG = 80, YG = 14
var gid = 1
function tw(s, isRoot) { return Math.max(isRoot ? 68 : 52, s.length * (isRoot ? 14 : 13) + (isRoot ? 48 : 38)) }

function build(spec, parent) {
  var n = { id: gid++, label: spec.label, children: [], parent: parent || null, depth: parent ? parent.depth + 1 : 0 }
  if (spec.children) for (var i = 0; i < spec.children.length; i++) n.children.push(build(spec.children[i], n))
  return n
}

function layout(n, x, y) {
  n.x = x; n.y = y; n.w = tw(n.label, n.depth === 0)
  var nodeH = n.depth === 0 ? NRH : NH
  if (!n.children.length) return nodeH
  var cy = y, cx = x + n.w + XG
  for (var i = 0; i < n.children.length; i++) {
    cy += layout(n.children[i], cx, cy)
    if (i < n.children.length - 1) cy += YG
  }
  return cy - y
}

function collect(n, nds, lns) {
  var pIdx = Math.min(n.depth, PAL.length - 1)
  nds.push({ id: n.id, label: n.label, x: n.x, y: n.y, w: n.w, depth: n.depth, gr: 'grd' + pIdx, brdr: PAL[pIdx].from })
  if (!n.children.length) return
  var nodeH = n.depth === 0 ? NRH : NH
  var x1 = n.x + n.w, y1 = n.y + nodeH / 2
  for (var i = 0; i < n.children.length; i++) {
    var c = n.children[i], ch = c.depth === 0 ? NRH : NH
    var x2 = c.x, y2 = c.y + ch / 2, mx = x1 + (x2 - x1) * 0.65
    lns.push({ id: c.id, d: 'M' + x1 + ',' + y1 + ' C' + mx + ',' + y1 + ' ' + mx + ',' + y2 + ' ' + x2 + ',' + y2, c: PAL[Math.min(c.depth, PAL.length - 1)].from })
    collect(c, nds, lns)
  }
}

function find(n, id) {
  if (n.id === id) return n
  for (var i = 0; i < n.children.length; i++) { var r = find(n.children[i], id); if (r) return r }
  return null
}

function treeToJSON(node) {
  var o = { label: node.label }; if (node.children.length) { o.children = []; for (var i = 0; i < node.children.length; i++) o.children.push(treeToJSON(node.children[i])) }
  return o
}

var SAMPLE = {
  label: '在线小工具', children: [
    { label: '文字处理', children: [{ label: '字数统计' }, { label: '大小写转换' }, { label: 'Markdown编辑' }] },
    { label: '图片工具', children: [{ label: '图片压缩' }, { label: '颜色选择器' }, { label: '二维码生成' }, { label: '颜色提取器' }] },
    { label: '网络查询', children: [{ label: 'DNS查询' }, { label: 'IP归属地' }, { label: 'HTTP状态码' }] },
    { label: '实用工具', children: [{ label: '房贷计算器' }, { label: '个税计算器' }, { label: 'UUID生成器' }, { label: '进制转换' }] },
    { label: '在线图表', children: [{ label: '流程图' }, { label: '思维导图' }, { label: '函数绘图' }] }
  ]
}

export default {
  name: 'MindMap',
  props: { config: { type: Object, default: function() { return {} } } },
  data: function() {
    gid = 1
    var root = build({ label: '中心主题', children: [] }, null)
    layout(root, 20, 40)
    var nds = [], lns = []; collect(root, nds, lns)
    return {
      tree: root, nodes: nds, lines: lns, svgW: 1200, svgH: 800,
      selId: null, editId: null, edText: '', renderKey: 0,
      themes: THEMES, activeTheme: 'default', bgColor: BG, dotColor: DOT, stageBg: BG,
      scale: 1, panX: 0, panY: 0, down: false, mx: 0, my: 0,
      gradients: PAL.map(function(p, i) { return { id: 'grd' + i, from: p.from, to: p.to } })
    }
  },
  computed: {
    edBox: function() {
      if (!this.editId) return null
      for (var i = 0; i < this.nodes.length; i++) if (this.nodes[i].id === this.editId) return { x: this.nodes[i].x - 1, y: this.nodes[i].y, w: this.nodes[i].w + 4, depth: this.nodes[i].depth }
      return null
    }
  },
  methods: {
    refresh: function() {
      layout(this.tree, 20, 40)
      var nds = [], lns = []; collect(this.tree, nds, lns)
      var mx = 0, my = 0
      for (var i = 0; i < nds.length; i++) { if (nds[i].x + nds[i].w > mx) mx = nds[i].x + nds[i].w; if (nds[i].y + NH + 20 > my) my = nds[i].y + NH + 20 }
      this.nodes = nds; this.lines = lns; this.svgW = Math.max(1200, mx + 200); this.svgH = Math.max(800, my + 60)
      this.renderKey++
    },
    startEdit: function(n) { this.editId = n.id; this.edText = n.label; this.selId = n.id; var s = this; this.$nextTick(function() { var e = s.$refs.ef; if (e) { e.focus(); e.select() } }) },
    finishEdit: function() { if (!this.editId) return; var nd = find(this.tree, this.editId); if (nd) nd.label = this.edText.trim() || nd.label; this.editId = null; this.edText = ''; this.refresh() },
    cancelEdit: function() { this.editId = null },
    addChild: function() {
      if (!this.selId) return; var nd = find(this.tree, this.selId); if (!nd) return
      nd.children.push({ id: gid++, label: '新主题', children: [], parent: nd, depth: nd.depth + 1 })
      this.refresh(); this.selId = nd.children[nd.children.length - 1].id
    },
    addSibling: function() {
      if (!this.selId) return; var nd = find(this.tree, this.selId); if (!nd || !nd.parent) return
      var idx = nd.parent.children.indexOf(nd)
      nd.parent.children.splice(idx + 1, 0, { id: gid++, label: '新主题', children: [], parent: nd.parent, depth: nd.depth })
      this.refresh(); this.selId = nd.parent.children[idx + 1].id
    },
    deleteNode: function() {
      if (!this.selId) return; var nd = find(this.tree, this.selId); if (!nd || !nd.parent) return
      var idx = nd.parent.children.indexOf(nd); if (idx >= 0) nd.parent.children.splice(idx, 1)
      this.selId = nd.parent.id; this.refresh()
    },
    onExport: function(cmd) { if (cmd === 'json') this.exportJSON(); if (cmd === 'markdown') this.exportMarkdown(); if (cmd === 'png') this.exportPNG() },
    exportJSON: function() {
      var json = JSON.stringify(treeToJSON(this.tree), null, 2)
      var a = document.createElement('a'); document.body.appendChild(a); a.href = URL.createObjectURL(new Blob([json], { type: 'application/json' })); a.download = 'mindmap.json'; a.click(); document.body.removeChild(a)
    },
    exportMarkdown: function() {
      function md(node, d) { var p = ''; for (var i = 0; i < d; i++) p += '#'; var l = [p + ' ' + node.label]; for (var i = 0; i < node.children.length; i++) l.push(md(node.children[i], d + 1)); return l.join('\n') }
      var a = document.createElement('a'); document.body.appendChild(a); a.href = URL.createObjectURL(new Blob([md(this.tree, 1)], { type: 'text/markdown' })); a.download = 'mindmap.md'; a.click(); document.body.removeChild(a)
    },
    exportPNG: function() {
      var svg = this.$el.querySelector('svg'); if (!svg) return
      var c = svg.cloneNode(true); c.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
      var data = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(new XMLSerializer().serializeToString(c))))
      var img = new Image(); img.onload = function() {
        var cv = document.createElement('canvas'); cv.width = this.width * 1.5; cv.height = this.height * 1.5
        var ctx = cv.getContext('2d'); ctx.scale(1.5, 1.5); ctx.drawImage(this, 0, 0)
        cv.toBlob(function(b) { var a = document.createElement('a'); document.body.appendChild(a); a.href = URL.createObjectURL(b); a.download = 'mindmap.png'; a.click(); document.body.removeChild(a) })
      }; img.src = data
    },
    onKey: function(e) {
      if (this.editId) return
      var nd = this.selId ? find(this.tree, this.selId) : null
      if (e.key === 'Tab') { e.preventDefault(); if (nd) this.addChild(); else this.selId = this.tree.id; return }
      if (e.key === 'Enter') { e.preventDefault(); if (nd && nd.parent) this.addSibling(); return }
      if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); if (nd && nd.parent) this.deleteNode(); return }
      if (e.key === 'F2') { e.preventDefault(); if (nd) this.startEdit({ id: nd.id, label: nd.label }); return }
      if (e.key === 'Escape') { e.preventDefault(); this.selId = null; return }
      if (!nd || !nd.parent) return
      var idx = nd.parent.children.indexOf(nd)
      if (e.key === 'ArrowUp' && idx > 0) { e.preventDefault(); this.selId = nd.parent.children[idx - 1].id }
      if (e.key === 'ArrowDown' && idx < nd.parent.children.length - 1) { e.preventDefault(); this.selId = nd.parent.children[idx + 1].id }
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.selId = nd.parent.id }
      if (e.key === 'ArrowRight' && nd.children.length) { e.preventDefault(); this.selId = nd.children[0].id }
    },
    z: function(d) { this.scale = Math.round(Math.max(0.3, Math.min(2, this.scale + d)) * 100) / 100 },
    onWheel: function(e) { this.panX -= e.deltaX / this.scale; this.panY -= e.deltaY / this.scale },
    onDown: function(e) { this.down = true; this.mx = e.clientX; this.my = e.clientY },
    onMove: function(e) { if (!this.down) return; this.panX += (e.clientX - this.mx) / this.scale; this.panY += (e.clientY - this.my) / this.scale; this.mx = e.clientX; this.my = e.clientY },
    onUp: function() { this.down = false },
    fit: function() { this.scale = 0.85; this.panX = 20; this.panY = 20 },
    switchTheme: function(key) {
      var t = THEMES[key]; if (!t) return
      this.activeTheme = key; PAL = t.pal; this.bgColor = t.bg; this.dotColor = t.dot; this.stageBg = t.bg
      this.gradients = t.pal.map(function(p, i) { return { id: 'grd' + i, from: p.from, to: p.to } })
      this.refresh()
    },
    loadSample: function() { gid = 100; this.tree = build(SAMPLE, null); this.selId = null; this.editId = null; this.refresh(); this.fit() },
    doAction: function(a) {
      if (a === 'clear') { gid = 1; this.tree = build({ label: '中心主题', children: [] }, null); this.selId = null; this.editId = null; this.refresh(); this.fit() }
      if (a === 'sample') this.loadSample()
    }
  }
}
</script>

<style>
.xmm { max-width: 100%; display: flex; flex-direction: column; outline: none; user-select: none; }
.xmm-bar { display: flex; align-items: center; justify-content: space-between; flex-shrink: 0; margin-bottom: 10px; gap: 12px; }
.xmm-keys { display: flex; gap: 8px; flex-wrap: wrap; }
.xmm-key { font-size: 12px; color: #8892a6; }
.xmm-key kbd { font-size: 11px; padding: 1px 5px; border: 1px solid #dcdfe6; border-radius: 3px; background: #fff; color: #606266; font-family: monospace; margin-right: 2px; }
.xmm-acts { display: flex; align-items: center; gap: 4px; flex-shrink: 0; }
.xmm-pct { font-size: 11px; color: #8892a6; min-width: 32px; text-align: center; }

.xmm-stage { flex: 1; border: 1px solid #e8eaef; border-radius: 10px; overflow: hidden; background: #fff; cursor: grab; min-height: 520px; }
.xmm-stage:active { cursor: grabbing; }
.xmm-world { transform-origin: 0 0; }
.xmm-inp { width: 100%; height: 100%; border: 2px solid #4e7cff; border-radius: 8px; padding: 0 10px; font-size: 13px; font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif; outline: none; background: #fff; color: #303133; box-sizing: border-box; box-shadow: 0 0 0 4px rgba(78,124,255,.08); }
.xmm-inp-root { font-weight: 700; font-size: 15px; }
</style>
